export default __webpack_public_path__ + "media/images/images_v2/onglet-gauchesmall-a498ac0006333a98055b2af3cc53d577.png";